var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 9.143c.206 0 .375-.16.375-.357V7.714C18 7.32 17.665 7 17.25 7H6.75c-.415 0-.75.32-.75.714v1.072c0 .196.169.357.375.357h11.25zM16.5 17c.415 0 .75-.32.75-.714V9.857H6.75v6.429c0 .395.335.714.75.714h9zm-3.281-5H10.78a.276.276 0 01-.281-.268v-.178c0-.148.127-.268.281-.268h2.438c.154 0 .281.12.281.268v.178a.276.276 0 01-.281.268z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/40d1019aa91b19f6b99f42afffac2f1f-Archive.svg";
export { SvgArchive as ReactComponent };